import { render, staticRenderFns } from "./Button2.vue?vue&type=template&id=5cd65f1a&scoped=true&"
import script from "./Button2.vue?vue&type=script&lang=js&"
export * from "./Button2.vue?vue&type=script&lang=js&"
import style0 from "./Button2.vue?vue&type=style&index=0&id=5cd65f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd65f1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
